import {createContext} from 'react'
import type {Connection, ConnectionId, GitHubRepository} from '@package/shared'
import type {
  AddConnectionRequest,
  UpdateConnectionRequest,
  UpdateGitHubRepositoryRequest,
} from '@app/api-resolver/router'

export type ConnectionsContextValue = {
  connections: Connection[]
  refetch: () => Promise<void>
  loading: boolean

  addConnection: (connection: AddConnectionRequest) => Promise<Connection>
  updateConnection: (connection: UpdateConnectionRequest) => Promise<Connection>
  deleteConnection: (connectionId: ConnectionId) => Promise<void>

  updateRepository: (request: UpdateGitHubRepositoryRequest) => Promise<Connection>
  disableRepository: (connectionId: ConnectionId, id: GitHubRepository['id']) => Promise<Connection>
  enableRepository: (connectionId: ConnectionId, id: GitHubRepository['id']) => Promise<Connection>

  saving: boolean

  refreshRecommendations: (connectionId: ConnectionId) => Promise<void>
  refreshingRecommendations: boolean
}

export const ConnectionsContext = createContext<ConnectionsContextValue>({} as ConnectionsContextValue)
